var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.135 22.1668C15.9607 22.1674 15.7885 22.129 15.631 22.0543C15.4735 21.9796 15.3348 21.8705 15.225 21.7352L9.58999 14.7352C9.41839 14.5264 9.32458 14.2646 9.32458 13.9943C9.32458 13.7241 9.41839 13.4622 9.58999 13.2535L15.4233 6.25349C15.6214 6.01524 15.9059 5.86541 16.2144 5.83697C16.5229 5.80852 16.8301 5.9038 17.0683 6.10183C17.3066 6.29985 17.4564 6.58442 17.4848 6.89291C17.5133 7.20141 17.418 7.50857 17.22 7.74683L12.005 14.0002L17.045 20.2535C17.1877 20.4247 17.2783 20.6333 17.3061 20.8544C17.334 21.0756 17.2979 21.3 17.2022 21.5013C17.1065 21.7026 16.9551 21.8723 16.7659 21.9902C16.5768 22.1081 16.3579 22.1694 16.135 22.1668Z",
    fill: "#4A5568"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prev-icon.e942c4485e2b8fb0e0fc78ff077b21e6.svg";
export { ForwardRef as ReactComponent };